module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('request-status', {
    attrs: {
      "request": _vm.req,
      "message200": false
    }
  }), _vm._v(" "), _c('request-status', {
    attrs: {
      "request": _vm.savereq,
      "message200": "Codes have been added"
    }
  }), _vm._v(" "), _c('v-card-title', {
    staticClass: "overline py-1 grey lighten-4"
  }, [_c('v-btn', {
    attrs: {
      "small": "",
      "icon": ""
    },
    on: {
      "click": _vm.get
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("replay")])], 1), _vm._v("\n    Copy codes from other appointments\n    "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', [(_vm.selectedIds && _vm.selectedIds.length > 0) ? _c('v-card', [_c('v-card-title', {
    staticClass: "overline py-1 grey lighten-4"
  }, [_vm._v("\n        Codes to add\n        "), _c('v-spacer')], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), [_vm._l((_vm.selectedItems), function(code) {
    return _c('v-card', {
      key: code.id,
      staticClass: "ml-3",
      attrs: {
        "flat": ""
      }
    }, [_c('v-layout', {
      attrs: {
        "row": ""
      }
    }, _vm._l((_vm.headers), function(field) {
      return _c('v-flex', {
        key: field.value
      }, [(field.value === "price") ? [_vm._v("\n                " + _vm._s(_vm.formatCurrency(code.currency, code.price)) + "\n              ")] : [_vm._v("\n                " + _vm._s(code[field.value]) + "\n              ")]], 2)
    }), 1), _vm._v(" "), _c('v-divider', {
      key: ("div-" + (code.id))
    })], 1)
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "mx-2 caption mt-0",
    attrs: {
      "dense": "",
      "persistent-hint": "",
      "label": "Clear existing codes",
      "hint": "Will remove any codes currently on this appointment - replacing them with the copied codes"
    },
    model: {
      value: (_vm.withClear),
      callback: function($$v) {
        _vm.withClear = $$v
      },
      expression: "withClear"
    }
  })], _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "flat": "",
      "small": ""
    },
    on: {
      "click": _vm.clear
    }
  }, [_vm._v("reset")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "loading": _vm.savereq.loading,
      "color": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Save")])], 1)], 2) : _vm._e(), _vm._v(" "), _c('v-subheader', {
    staticClass: "overline"
  }, [_vm._v("Choose codes from previous appointments")]), _vm._v(" "), (!_vm.req.loading && _vm.appointments && _vm.appointments.length === 0) ? [_c('span', {
    staticClass: "ml-3"
  }, [_vm._v("Couldn't find any other appointments with codes added for this client")])] : _vm._e(), _vm._v(" "), _c('v-expansion-panel', _vm._l((_vm.appointments), function(appt) {
    return _c('v-expansion-panel-content', {
      key: appt.id,
      scopedSlots: _vm._u([{
        key: "header",
        fn: function() {
          return [_vm._v("\n          " + _vm._s(appt.title) + ". " + _vm._s(_vm.dateformat(appt.start_time)) + "\n          "), _c('v-spacer')]
        },
        proxy: true
      }], null, true)
    }, [_vm._v(" "), (appt && appt.codes) ? _vm._l((appt.codes), function(code) {
      return _c('v-card', {
        key: code.id,
        staticClass: "ml-3",
        on: {
          "click": function($event) {
            return _vm.toggleCode(code)
          }
        }
      }, [_c('v-layout', {
        attrs: {
          "row": ""
        }
      }, [_c('v-flex', {
        attrs: {
          "xs1": ""
        }
      }, [(_vm.selectedIds.indexOf(code.id) === -1) ? _c('v-icon', {
        attrs: {
          "small": ""
        }
      }, [_vm._v("check_box_outline_blank")]) : _c('v-icon', {
        attrs: {
          "small": ""
        }
      }, [_vm._v("check_box_outline")])], 1), _vm._v(" "), _vm._l((_vm.headers), function(field) {
        return _c('v-flex', {
          key: field.value
        }, [(field.value === "price") ? [_vm._v("\n                  " + _vm._s(_vm.formatCurrency(code.currency, code.price)) + "\n                ")] : [_vm._v("\n                  " + _vm._s(code[field.value]) + "\n                ")]], 2)
      })], 2), _vm._v(" "), _c('v-divider', {
        key: ("div-" + (code.id)),
        staticClass: "mb-2"
      })], 1)
    }) : _vm._e()], 2)
  }), 1)], 2), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit("close")
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-spacer')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-317eba92","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/appointment/CopyCodes.vue
// module id = 1380
// module chunks = 9